// Module Registry for EzERP
import { 
  LayoutGrid, 
  Truck, 
  Warehouse, 
  DollarSign, 
  ShoppingCart, 
  Users,
  MessageSquare,
  Network,
  Calendar,
  KanbanSquare,
  Store,
  Share2,
  UserCheck,
  BookOpen,
  Presentation,
  FileCheck
} from 'lucide-react';

export const MODULES = {
  ERP_DASHBOARD: {
    id: 'erp',
    name: 'ERP Dashboard',
    path: '/',
    icon: LayoutGrid,
    enabled: true,
    color: '#6366f1',
    description: 'Cross-module overview and analytics',
    badge: null
  },
  
  EZPARCEL: {
    id: 'ezparcel',
    name: 'Logistics & Delivery',
    path: '/ezparcel',
    icon: Truck,
    enabled: true,
    color: '#dc2626',
    description: 'Parcel logistics and delivery operations',
    badge: 'Active',
    subModules: [
      { name: 'Dashboard', path: '/ezparcel/dashboard' },
      { name: 'Fleet Management', path: '/ezparcel/fleet' },
      { name: 'Shipments', path: '/ezparcel/shipments' },
      { name: 'Routes', path: '/ezparcel/routes' },
      { name: 'Drivers', path: '/ezparcel/drivers' },
      { name: 'Vehicles', path: '/ezparcel/vehicles' },
      { name: 'Warehouses', path: '/ezparcel/warehouses' },
      { name: 'Customers', path: '/ezparcel/customers' },
      { name: 'Billing', path: '/ezparcel/billing' },
      { name: 'Reports', path: '/ezparcel/reports' },
      { name: 'Documents', path: '/ezparcel/documents' },
      { name: 'Integrations', path: '/ezparcel/integrations' },
      { name: 'Communications', path: '/ezparcel/communications' }
    ]
  },
  
  WMS: {
    id: 'wms',
    name: 'Warehouse Management',
    path: '/wms',
    icon: Warehouse,
    enabled: true,
    color: '#2563eb',
    description: 'Complete warehouse operations',
    badge: 'Active',
    subModules: [
      { name: 'Dashboard', path: '/wms/dashboard' },
      { name: 'Inventory', path: '/wms/inventory' },
      { name: 'PharmaScan', path: '/wms/pharmascan' },
      { name: 'Products', path: '/wms/products' },
      { name: 'Receiving', path: '/wms/receiving' },
      { name: 'Putaway', path: '/wms/putaway' },
      { name: 'Picking', path: '/wms/picking' },
      { name: 'Packing', path: '/wms/packing' },
      { name: 'Pallets', path: '/wms/pallets' },
      { name: 'Expedition', path: '/wms/expedition' }
    ]
  },
  
  FINANCE: {
    id: 'finance',
    name: 'Financial Management',
    path: '/finance',
    icon: DollarSign,
    enabled: true,
    color: '#16a34a',
    description: 'Accounting and financial operations',
    badge: 'Active',
    subModules: [
      { name: 'Dashboard', path: '/finance/dashboard' },
      { name: 'General Ledger', path: '/finance/general-ledger' },
      { name: 'Accounts Payable', path: '/finance/accounts-payable' },
      { name: 'Accounts Receivable', path: '/finance/accounts-receivable' },
      { name: 'Fixed Assets', path: '/finance/fixed-assets' },
      { name: 'Tax Management', path: '/finance/tax' },
      { name: 'Banking', path: '/finance/banking' },
      { name: 'Financial Reports', path: '/finance/reports' },
      { name: 'Expense Claims', path: '/finance/expenses' }
    ]
  },
  
  PROCUREMENT: {
    id: 'procurement',
    name: 'Procurement',
    path: '/procurement',
    icon: ShoppingCart,
    enabled: true,
    color: '#4f46e5',
    description: 'Purchase orders and vendor management',
    badge: 'Active',
    subModules: [
      { name: 'Dashboard', path: '/procurement/dashboard' },
      { name: 'Vendors', path: '/procurement/vendors' },
      { name: 'Purchase Orders', path: '/procurement/purchase-orders' },
      { name: 'RFQ Management', path: '/procurement/rfq' },
      { name: 'Goods Receipt', path: '/procurement/goods-receipt' },
      { name: 'Vendor Payments', path: '/procurement/payments' },
      { name: 'Reports', path: '/procurement/reports' }
    ]
  },
  
  ECOMMERCE: {
    id: 'ecommerce',
    name: 'Ecommerce',
    path: '/ecommerce',
    icon: Store,
    enabled: true,
    color: '#10b981',
    description: 'Online storefronts and sales channels',
    badge: 'New',
    subModules: [
      { name: 'Dashboard', path: '/ecommerce/dashboard' },
      { name: 'Storefront Builder', path: '/ecommerce/builder' },
      { name: 'My Stores', path: '/ecommerce/stores' },
      { name: 'Products', path: '/ecommerce/products' },
      { name: 'Orders', path: '/ecommerce/orders' }
    ]
  },
  
  CRM: {
    id: 'crm',
    name: 'CRM',
    path: '/crm',
    icon: Users,
    enabled: true,
    color: '#14b8a6',
    description: 'Customer relationship management',
    badge: 'Active',
    subModules: [
      { name: 'Dashboard', path: '/crm/dashboard' },
      { name: 'Leads', path: '/crm/leads' },
      { name: 'Prospect Discovery', path: '/crm/prospect-discovery' },
      { name: 'Pipeline', path: '/crm/pipeline' },
      { name: 'Opportunities', path: '/crm/opportunities' },
      { name: 'Quotes', path: '/crm/quotes' },
      { name: 'Campaign Intelligence', path: '/crm/campaign-intelligence' },
      { name: 'Sales & Marketing Hub', path: '/crm/marketing-hub' },
      { name: 'Accounts', path: '/crm/accounts' },
      { name: 'Orchestration', path: '/crm/orchestration' },
      { name: 'Brand Protection', path: '/crm/brand-protection' },
      { name: 'Portal Manager', path: '/crm/portal-manager' },
      { name: 'Publishing Console', path: '/crm/publishing-console' },
      { name: 'Ad Connectors', path: '/crm/ad-connectors' },
      { name: 'Activities', path: '/crm/activities' },
      { name: 'Reports', path: '/crm/reports' },
      { name: 'The Presentation HUB', path: '/crm/presentation-hub', icon: Presentation }
    ]
  },
  COMMUNICATIONS: {
    id: 'communications',
    name: 'Communications',
    path: '/communications',
    icon: MessageSquare,
    enabled: true,
    color: '#8b5cf6',
    description: 'Multi-channel messaging hub',
    badge: 'Active',
    subModules: [
      { name: 'Dashboard', path: '/communications/dashboard' },
      { name: 'Telegram', path: '/communications/telegram' },
      { name: 'WhatsApp', path: '/communications/whatsapp' },
      { name: 'SMS', path: '/communications/sms' },
      { name: 'Email', path: '/communications/email' },
      { name: 'Templates', path: '/communications/templates' },
      { name: 'Rules', path: '/communications/rules' },
      { name: 'Logs', path: '/communications/logs' }
    ]
  },
  OIG: {
    id: 'oig',
    name: 'OIG',
    fullName: 'Integration Gateway',
    icon: Network,
    path: '/oig',
    enabled: true,
    color: '#06b6d4',
    description: 'Document ingestion & EDI',
    badge: 'Active',
    subModules: [
      { name: 'Dashboard', path: '/oig/dashboard' },
      { name: 'NF-e', path: '/oig/nfe' },
      { name: 'NF-e Config', path: '/oig/nfe/config' },
      { name: 'NF-e Upload', path: '/oig/nfe/upload' },
      { name: 'CT-e', path: '/oig/cte' },
      { name: 'EDI Partners', path: '/oig/edi' },
      { name: 'CSV Import', path: '/oig/csv' },
      { name: 'History', path: '/oig/history' }
    ]
  },
  CALENDAR: {
    id: 'calendar',
    name: 'Calendar',
    fullName: 'Enterprise Calendar',
    icon: Calendar,
    path: '/calendar',
    enabled: true,
    color: '#3b82f6',
    description: 'Multi-tenant calendar with event rules and external sync',
    badge: 'New',
    subModules: [
      { name: 'Calendar', path: '/calendar' },
      { name: 'Event Rules', path: '/calendar/rules' },
      { name: 'Holidays', path: '/calendar/holidays' },
      { name: 'Working Hours', path: '/calendar/working-hours' },
      { name: 'External Sync', path: '/calendar/sync' }
    ]
  },
  EZTASK: {
    id: 'eztask',
    name: 'EzTask',
    fullName: 'Project Management',
    icon: KanbanSquare,
    path: '/eztask',
    enabled: true,
    color: '#f59e0b',
    description: 'Kanban-style project and task management',
    badge: 'New',
    subModules: [
      { name: 'Boards', path: '/eztask' },
      { name: 'Dashboard', path: '/eztask/dashboard' }
    ]
  },
  CNS: {
    id: 'cns',
    name: 'Social Media',
    fullName: 'Social Media Management',
    icon: Share2,
    path: '/cns',
    enabled: true,
    color: '#ec4899',
    description: 'Social media marketing and content management',
    badge: 'New',
    subModules: [
      { name: 'Dashboard', path: '/cns/dashboard' },
      { name: 'Content Studio', path: '/cns/content' },
      { name: 'Scheduler', path: '/cns/scheduler' },
      { name: 'Channels', path: '/cns/channels' },
      { name: 'Campaigns', path: '/cns/campaigns' },
      { name: 'Analytics', path: '/cns/analytics' },
      { name: 'Email Marketing', path: '/cns/email' },
      { name: 'Ads Manager', path: '/cns/ads' },
      { name: 'Settings', path: '/cns/settings' }
    ]
  },
  REPORTS: {
    id: 'reports',
    name: 'Report Builder',
    fullName: 'Report Builder',
    icon: LayoutGrid,
    path: '/reports',
    enabled: true,
    color: '#3b82f6',
    description: 'Create and schedule custom reports',
    badge: 'New',
    subModules: [
      { name: 'My Reports', path: '/reports' },
      { name: 'New Report', path: '/reports/new' },
      { name: 'Report Types', path: '/reports/types' }
    ]
  },
  HR: {
    id: 'hr',
    name: 'Human Resources',
    fullName: 'Human Resources',
    icon: UserCheck,
    path: '/hr',
    enabled: true,
    color: '#7c3aed',
    description: 'Employee management, payroll, and time tracking',
    badge: 'New',
    subModules: [
      { name: 'Dashboard', path: '/hr/dashboard' },
      { name: 'Employees', path: '/hr/employees' },
      { name: 'Time & Attendance', path: '/hr/time-attendance' },
      { name: 'Leave Management', path: '/hr/leave' },
      { name: 'Payroll', path: '/hr/payroll' },
      { name: 'Pay Components', path: '/hr/pay-components' },
      { name: 'Shifts', path: '/hr/shifts' },
      { name: 'Positions', path: '/hr/positions' }
    ]
  },
  ACCOUNTING: {
    id: 'accounting',
    name: 'Accounting',
    fullName: 'Accounting Ledger',
    icon: BookOpen,
    path: '/accounting',
    enabled: true,
    color: '#059669',
    description: 'General ledger, journal entries, and period close',
    badge: 'New',
    subModules: [
      { name: 'Dashboard', path: '/accounting/dashboard' },
      { name: 'Chart of Accounts', path: '/accounting/chart-of-accounts' },
      { name: 'Journal Entries', path: '/accounting/journals' },
      { name: 'Event Inbox', path: '/accounting/events' },
      { name: 'Period Close', path: '/accounting/periods' },
      { name: 'Statutory Exports', path: '/accounting/exports' },
      { name: 'Posting Rules', path: '/accounting/posting-rules' }
    ]
  },
  FISCAL: {
    id: 'fiscal',
    name: 'Fiscal Engine',
    fullName: 'Brazil Fiscal Engine',
    icon: FileCheck,
    path: '/fiscal',
    enabled: true,
    color: '#dc2626',
    description: 'Brazil fiscal documents, apuracao, SPED/EFD, and audit evidence',
    badge: 'New',
    subModules: [
      { name: 'Dashboard', path: '/fiscal/dashboard' },
      { name: 'Fiscal Documents', path: '/fiscal/documents' },
      { name: 'Apuração', path: '/fiscal/apuracao' },
      { name: 'SPED / EFD', path: '/fiscal/sped' },
      { name: 'Fiscal Matrix', path: '/fiscal/matrix' },
      { name: 'Fiscal Events', path: '/fiscal/events' },
      { name: 'Audit Evidence', path: '/fiscal/audit' }
    ]
  }
};

export const getActiveModules = () => {
  return Object.values(MODULES).filter(module => module.enabled);
};

export const getModuleByPath = (pathname) => {
  return Object.values(MODULES).find(module => 
    pathname.startsWith(module.path) && module.path !== '/'
  ) || MODULES.ERP_DASHBOARD;
};
